<template>
  <div>
    <div
      class="painel-container"
      :style="
        'width: 100vw; min-height: 100vh;' +
        'background: ' +
        (configuracao.degrade
          ? 'radial-gradient(' + configuracao.background + ', #000000);'
          : configuracao.background)
      "
    >
      <div v-if="found && senhaAtual" class="painel-content">
        <!-- Header com a Senha -->
        <div class="senha-header">
          <div class="senha-text">
            <span class="senha-label">SENHA</span>
            <span class="senha-numero">{{ senhaAtual.senha }}</span>
          </div>
        </div>

        <!-- Informação do Setor -->
        <div v-if="senhaAtual.setor" class="setor-info">
          <strong>Setor:</strong> {{ senhaAtual.setor }}
        </div>

        <!-- Botão Senha Preferencial (se aplicável) -->
        <div v-if="senhaAtual.prioridade > 1" class="btn-preferencial">
          SENHA PREFERENCIAL - {{ senhaAtual.prioridade_f }}
        </div>

        <!-- Botão Editar Informações -->
        <div
          class="btn-editar"
          data-toggle="modal"
          data-target="#modalEditarPessoa"
          @click="abrirModalEdicao()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            style="margin-right: 8px"
          >
            <path
              d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
            ></path>
            <path
              d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
            ></path>
          </svg>
          EDITAR INFORMAÇÕES DE CHECK-IN
        </div>

        <!-- Modal Editar Pessoa -->
        <div
          class="modal fade"
          id="modalEditarPessoa"
          tabindex="-1"
          role="dialog"
          aria-labelledby="modalEditarPessoaLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header bg-primary">
                <h5
                  class="modal-title"
                  style="color: #eee"
                  id="modalEditarPessoaLabel"
                >
                  Cadastramento facial
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="fecharCamera()"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-6 mt-1">
                    <label>CPF*</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        v-model="pessoa.cpf"
                        v-mask="'999.999.999-99'"
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-primary"
                          type="button"
                          @click="getCpf()"
                        >
                          <i class="fas fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-1">
                    <label>Data de Nascimento</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="pessoa.data_nascimento_form"
                    />
                  </div>
                  <div class="col-12 mt-1">
                    <label>Nome *</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.nome_social"
                    />
                  </div>
                  <div class="col-12">
                    <label>Nome mãe</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.nome_mae"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>Telefone *</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.telefone"
                      v-mask="'(99) 99999-9999'"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>Gênero *</label>
                    <select class="form-control" v-model="pessoa.sexo">
                      <option value="">Selecione</option>
                      <option value="M">Masculino</option>
                      <option value="F">Feminino</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label>RG</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.rg"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>CNS</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.cns"
                    />
                  </div>
                  <div class="col-12">
                    <label>Email</label>
                    <input
                      type="email"
                      class="form-control"
                      v-model="pessoa.email"
                    />
                  </div>
                  <div class="col-12">
                    <label>Alergias</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.alergias"
                    />
                  </div>
                  <div class="col-12">
                    <label>CEP</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.cep"
                      v-mask="'99999-999'"
                      @input="getEndereco()"
                    />
                  </div>
                  <div class="col-12">
                    <label>Logradouro</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.logradouro"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>Número</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.numero"
                    />
                  </div>
                  <div class="col-md-6">
                    <label>Complemento</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.complemento"
                    />
                  </div>
                  <div class="col-12">
                    <label>Bairro</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.bairro"
                    />
                  </div>
                  <div class="col-12">
                    <label>Cidade</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.cidade"
                    />
                  </div>
                  <div class="col-12 mb-1">
                    <label>Estado</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="pessoa.estado"
                      maxlength="2"
                    />
                  </div>
                  <div class="col-12 mb-2">
                    <label>Captura Facial</label>
                    <div
                      class="video-container"
                      style="
                        background: #000;
                        border-radius: 8px;
                        overflow: hidden;
                      "
                    >
                      <video
                        ref="video"
                        width="100%"
                        height="auto"
                        style="display: block; transform: scaleX(-1)"
                        playsinline
                      ></video>
                    </div>
                    <canvas
                      ref="canvas"
                      width="640"
                      height="480"
                      style="display: none"
                    ></canvas>
                  </div>
                  <div class="col-12 text-center my-2">
                    <button
                      v-if="!cameraAtiva"
                      class="btn btn-success mr-2"
                      @click="iniciarCamera"
                    >
                      <i class="fas fa-video mr-1"></i>
                      Ligar Câmera
                    </button>
                    <button
                      v-if="cameraAtiva"
                      class="btn btn-primary"
                      @click="tirarFoto"
                    >
                      <i class="fas fa-camera mr-1"></i>
                      Tirar Foto e Salvar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Se está AGUARDANDO (status 1) -->
        <div
          v-if="
            senhaAtual.status == 1 && senhaAtual.data_ultima_chamada == null
          "
        >
          <!-- Círculo de Progresso com Posição -->
          <div class="progress-circle-container">
            <svg
              class="progress-ring"
              width="240"
              height="240"
              viewBox="0 0 240 240"
            >
              <circle
                class="progress-ring-circle-bg"
                stroke="#e0e0e0"
                stroke-width="15"
                fill="transparent"
                r="110"
                cx="120"
                cy="120"
              />
              <circle
                class="progress-ring-circle"
                stroke="#17a2b8"
                stroke-width="15"
                fill="transparent"
                r="110"
                cx="120"
                cy="120"
                :style="
                  'stroke-dasharray: ' +
                  (posicao > 0
                    ? 691 * ((senhas.length - posicao + 1) / senhas.length)
                    : 691) +
                  ' 691'
                "
              />
            </svg>
            <div class="progress-content">
              <div class="posicao-label">Sua posição</div>
              <div class="posicao-numero">
                {{ posicao > 0 ? posicao : "-" }}
              </div>
            </div>
          </div>

          <!-- Card com Horário Previsto -->
          <div class="horario-card">
            <div class="horario-title">Horário previsto para atendimento</div>
            <div class="horario-valor">{{ tempoEspera }}</div>
            <div class="horario-obs">
              A previsão pode variar durante sua espera.
            </div>
          </div>
        </div>

        <!-- Se foi CHAMADO (status 2 OU data_ultima_chamada != null) -->
        <div
          v-else-if="
            senhaAtual.status == 2 || senhaAtual.data_ultima_chamada != null
          "
        >
          <div class="chamada-card">
            <div class="chamada-titulo">CHEGOU A SUA VEZ!</div>
            <div class="chamada-destino">
              Dirija-se para<br />
              <strong>{{ senhaAtual.setor }}</strong>
              <span v-if="senhaAtual.local"> - {{ senhaAtual.local }}</span>
            </div>
            <div class="chamada-vezes">
              Sua senha foi chamada {{ senhaAtual.vezes_chamado }} vez<span
                v-if="senhaAtual.vezes_chamado > 1"
                >es</span
              >.
            </div>
          </div>
        </div>

        <!-- Outro status -->
        <div v-else>
          <div class="horario-card">
            <div class="horario-title">
              Status: {{ senhaAtual.status_text }}
            </div>
          </div>
        </div>
      </div>

      <!-- Senha não encontrada -->
      <div v-else class="painel-content">
        <div
          class="card d-flex justify-content-center align-items-center w-100 px-3 py-5"
          :style="'color:' + configuracao.cor_primaria + ';'"
        >
          <h2 class="text-center">
            A senha procurada não existe ou já foi atendida
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BCardText, BLink } from "bootstrap-vue";
import { BCard, BCardBody, BAvatar } from "bootstrap-vue";

export default {
  data() {
    return {
      configuracao: {
        degrade: true,
        background: "#1e40af",
        cor_primaria: "#17a2b8",
      },
      found: false,
      posicao: 0,
      senhaAtual: null,
      senhas: [],
      tempoEspera: "--:--",
      pollingInterval: null, // Para controlar o setInterval
      pessoa: {
        cpf: "",
        nome: "",
        nome_social: "",
        nome_mae: "",
        nome_pai: "",
        cns: "",
        sexo: "",
        data_nascimento: "",
        data_nascimento_form: "",
        telefone: "",
        cep: "",
        logradouro: "",
        bairro: "",
        cidade: "",
        estado: "",
        numero: "",
        complemento: "",
        rg: "",
        email: "",
        alergias: "",
        foto: "",
      },
      stream: null,
      fotoUrl: null,
      cameraAtiva: false,
    };
  },
  components: {
    BCard,
    BCardText,
    BLink,
    BCardBody,
    BAvatar,
  },
  methods: {
    login() {
      const self = this;
      const api = self.$store.state.api + "login";

      axios
        .post(api, {
          email: "luan@it4d.com.br",
          password: "password",
        })
        .then((response) => {
          self.$store.commit("auth", response.data.access_token);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getSenha: function (id) {
      const self = this;
      let api =
        self.$store.state.api +
        "senha_temporarias?paginated=false&orderByDesc=data_entrada&atendimento_id=" +
        id;

      if (self.unidadeId) {
        api += "&unidade_id=" + self.unidadeId;
      }

      axios
        .get(api)
        .then((response) => {
          if (!response.data.data || !response.data.data.length) {
            self.found = false;
            return;
          }

          self.found = true;
          self.senhaAtual = response.data.data[0];

          if (self.senhaAtual.prioridade > 1) {
            self.senhaAtual.prioridade_f = "PRIORITÁRIA";
          }

          const statusMap = {
            1: "AGUARDANDO",
            2: "EM ATENDIMENTO",
            3: "ATENDIDO",
            4: "CANCELADO",
          };
          self.senhaAtual.status_text =
            statusMap[self.senhaAtual.status] || "DESCONHECIDO";

          self.getFila(id);
          self.dadosCompletos = true;

          // Polling a cada 30 segundos (reduzido de 5s para não sobrecarregar)
          self.pollingInterval = setInterval(() => {
            self.getFila(id);
            self.atualizarSenhaAtual(id);
          }, 30000);
        })
        .catch((error) => {
          console.log("Erro ao buscar senha:", error);
        });
    },
    atualizarSenhaAtual: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "senha_temporarias?paginated=false&orderByDesc=data_entrada&atendimento_id=" +
        id;

      axios
        .get(api)
        .then((response) => {
          if (response.data.data.length) {
            const novaSenha = response.data.data[0];
            self.senhaAtual.status = novaSenha.status;
            self.senhaAtual.vezes_chamado = novaSenha.vezes_chamado;
            self.senhaAtual.data_ultima_chamada = novaSenha.data_ultima_chamada;

            const statusMap = {
              1: "AGUARDANDO",
              2: "EM ATENDIMENTO",
              3: "ATENDIDO",
              4: "CANCELADO",
            };
            self.senhaAtual.status_text =
              statusMap[novaSenha.status] || "DESCONHECIDO";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getFila: function (atendimentoId) {
      const self = this;
      let api = self.$store.state.api + "fila-senha/" + atendimentoId;

      if (self.unidadeId) {
        api += "?unidade_id=" + self.unidadeId;
      }

      axios
        .get(api)
        .then((response) => {
          self.senhas = response.data;

          self.posicao = 0;
          self.senhas.forEach((senha, index) => {
            if (senha.atendimento_id === self.senhaAtual.atendimento_id) {
              self.posicao = index + 1;
            }
          });

          // Calcula tempo estimado após atualizar posição
          self.calcularTempoEstimado();

          self.dadosCompletos = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    calcularTempoEstimado: function () {
      const self = this;

      // Usa o tempo médio que vem calculado do SIGAP Local (formato HH:MM:SS)
      if (self.senhaAtual && self.senhaAtual.tempo_medio_atendimento) {
        const tempoMedioString = self.senhaAtual.tempo_medio_atendimento; // Ex: "00:03:01"

        // Converte HH:MM:SS para segundos
        const parts = tempoMedioString.split(":");
        const tempoMedioSegundos =
          parseInt(parts[0]) * 3600 +
          parseInt(parts[1]) * 60 +
          parseInt(parts[2]);

        // Multiplica pelo número de pessoas na frente
        const pessoasNaFrente = self.posicao > 1 ? self.posicao - 1 : 0;
        const tempoEstimadoSegundos = tempoMedioSegundos * pessoasNaFrente;

        // Calcula o horário previsto
        const agora = new Date();
        const horarioPrevisto = new Date(
          agora.getTime() + tempoEstimadoSegundos * 1000
        );

        // Formata o horário
        const horas = String(horarioPrevisto.getHours()).padStart(2, "0");
        const minutos = String(horarioPrevisto.getMinutes()).padStart(2, "0");

        self.tempoEspera = `${horas}:${minutos}`;
      } else {
        self.tempoEspera = "--:--";
      }
    },
    abrirModalEdicao: function () {
      const self = this;

      // Garante que a câmera está desligada ao abrir o modal
      self.fecharCamera();
      self.cameraAtiva = false;

      // Limpa o formulário (inicial)
      self.pessoa = {
        cpf: "",
        nome: "",
        nome_social: "",
        nome_mae: "",
        nome_pai: "",
        cns: "",
        sexo: "",
        data_nascimento: "",
        data_nascimento_form: "",
        telefone: "",
        cep: "",
        logradouro: "",
        bairro: "",
        cidade: "",
        estado: "",
        numero: "",
        complemento: "",
        rg: "",
        email: "",
        alergias: "",
        foto: "",
      };

      // Tentar carregar uma pessoa já vinculada a este atendimento/unidade
      if (self.senhaAtual && self.senhaAtual.atendimento_id) {
        const api = self.$store.state.api + "pessoas";

        axios
          .get(api, {
            params: {
              atendimento_id: self.senhaAtual.atendimento_id,
              unidade_id: self.unidadeId,
              per_page: 1,
            },
          })
          .then((response) => {
            // resposta pode variar: {data: [...] } ou [] ou {data: {}} dependendo do servidor
            let pessoa = null;

            if (response.data) {
              if (Array.isArray(response.data) && response.data.length > 0) {
                pessoa = response.data[0];
              } else if (
                Array.isArray(response.data.data) &&
                response.data.data.length > 0
              ) {
                pessoa = response.data.data[0];
              } else if (
                response.data.data &&
                !Array.isArray(response.data.data)
              ) {
                pessoa = response.data.data;
              } else if (response.data.id) {
                pessoa = response.data;
              }
            }

            if (pessoa) {
              // Mapear campos para o formulário
              self.pessoa.id = pessoa.id || null;
              self.pessoa.cpf = pessoa.cpf || "";
              self.pessoa.cns = pessoa.cns || "";
              self.pessoa.nome = pessoa.nome || "";
              self.pessoa.nome_social = pessoa.nome_social || pessoa.nome || "";
              self.pessoa.nome_mae = pessoa.nome_mae || "";
              self.pessoa.nome_pai = pessoa.nome_pai || "";
              self.pessoa.cep = pessoa.cep || "";
              self.pessoa.logradouro = pessoa.logradouro || "";
              self.pessoa.numero = pessoa.numero || "";
              self.pessoa.complemento = pessoa.complemento || "";
              self.pessoa.bairro = pessoa.bairro || "";
              self.pessoa.cidade = pessoa.cidade || "";
              self.pessoa.estado = pessoa.estado || "";
              self.pessoa.telefone = pessoa.telefone || "";
              self.pessoa.rg = pessoa.rg || "";
              self.pessoa.email = pessoa.email || "";
              self.pessoa.alergias = pessoa.alergias || "";
              self.pessoa.data_nascimento = pessoa.data_nascimento || "";
              // Suporta formatos com 'T' (ISO) ou com espaço ' ' (MySQL DATETIME)
              if (pessoa.data_nascimento) {
                if (pessoa.data_nascimento.includes("T")) {
                  self.pessoa.data_nascimento_form =
                    pessoa.data_nascimento.split("T")[0];
                } else if (pessoa.data_nascimento.includes(" ")) {
                  self.pessoa.data_nascimento_form =
                    pessoa.data_nascimento.split(" ")[0];
                } else {
                  self.pessoa.data_nascimento_form = pessoa.data_nascimento;
                }
              } else {
                self.pessoa.data_nascimento_form = "";
              }
              self.pessoa.sexo = pessoa.sexo || "";
              self.pessoa.foto = pessoa.foto || "";
            }
          })
          .catch((err) => {
            console.warn("Não foi possível carregar pessoa vinculada:", err);
          });
      }
    },
    getCpf: function () {
      const self = this;

      if (self.pessoa.cpf && self.pessoa.cpf.split("")[13] !== "_") {
        const api = self.$store.state.api + "get-cpf";

        axios
          .post(api, {
            documento: self.pessoa.cpf.replace("-", "").replaceAll(".", ""),
            tipoDocumento: "CPF",
          })
          .then((response) => {
            if (response.data.erro) {
              return self.$message("Atenção!", "CPF não encontrado", "warning");
            }

            const dados = response.data.content;

            self.pessoa.nome = dados.nome;
            self.pessoa.nome_social = dados.nomeSocial || dados.nome;
            self.pessoa.nome_mae = dados.nomeMae;
            self.pessoa.nome_pai = dados.nomePai;
            self.pessoa.cns = dados.codigoCNS;
            self.pessoa.cpf = dados.cpf;
            self.pessoa.sexo = dados.sexo;
            self.pessoa.data_nascimento = dados.dataNascimento;
            // aceita formatos com 'T' ou espaço
            if (dados.dataNascimento) {
              if (dados.dataNascimento.includes("T")) {
                self.pessoa.data_nascimento_form =
                  dados.dataNascimento.split("T")[0];
              } else if (dados.dataNascimento.includes(" ")) {
                self.pessoa.data_nascimento_form =
                  dados.dataNascimento.split(" ")[0];
              } else {
                self.pessoa.data_nascimento_form = dados.dataNascimento;
              }
            } else {
              self.pessoa.data_nascimento_form = "";
            }
            self.pessoa.telefone =
              dados.telefoneCelular || dados.telefoneResidencial || "";
            self.pessoa.cep = dados.cep;
            self.pessoa.logradouro = dados.logradouro;
            self.pessoa.bairro = dados.bairro;
            self.pessoa.cidade = dados.municipio;
            self.pessoa.estado = dados.estado;
            self.pessoa.numero = dados.numero;
            self.pessoa.complemento = dados.complemento;

            self.$message("Pessoa encontrada", dados.nome, "success");
          })
          .catch(() => {
            self.$message("Atenção!", "CPF não encontrado", "warning");
          });
      }
    },
    getEndereco: function () {
      const self = this;

      if (self.pessoa.cep && self.pessoa.cep.length === 9) {
        const cep = self.pessoa.cep.replace("-", "");
        const api = `https://viacep.com.br/ws/${cep}/json/`;

        axios
          .get(api)
          .then((response) => {
            if (!response.data.erro) {
              self.pessoa.logradouro = response.data.logradouro;
              self.pessoa.bairro = response.data.bairro;
              self.pessoa.cidade = response.data.localidade;
              self.pessoa.estado = response.data.uf;
            }
          })
          .catch((error) => {
            console.log("Erro ao buscar CEP:", error);
          });
      }
    },
    async iniciarCamera() {
      const self = this;
      try {
        self.stream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: { ideal: 1280 },
            height: { ideal: 720 },
            facingMode: "user", // Força câmera frontal
          },
        });

        self.$refs.video.srcObject = self.stream;

        // Aguarda o vídeo estar pronto e inicia a reprodução
        await self.$refs.video.play();
        self.cameraAtiva = true;

        self.$message(
          "Câmera ativada",
          "Câmera iniciada com sucesso",
          "success"
        );
      } catch (error) {
        console.error("Erro ao acessar a câmera:", error);
        self.cameraAtiva = false;
        self.$message(
          "Erro na câmera",
          "Não foi possível acessar a câmera. Verifique as permissões.",
          "error"
        );
      }
    },
    tirarFoto() {
      const self = this;

      if (!self.cameraAtiva) {
        self.$message(
          "Atenção",
          "Por favor, ligue a câmera primeiro",
          "warning"
        );
        return;
      }

      const video = self.$refs.video;
      const canvas = self.$refs.canvas;

      if (!video || !canvas) {
        self.$message("Erro", "Elementos de vídeo não encontrados", "error");
        return;
      }

      // Ajusta o canvas para o tamanho real do vídeo
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const context = canvas.getContext("2d");

      // Espelha horizontalmente antes de desenhar
      context.translate(canvas.width, 0);
      context.scale(-1, 1);

      // Desenha a imagem do vídeo no canvas (espelhada)
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      // Reseta a transformação
      context.setTransform(1, 0, 0, 1, 0, 0);

      self.fotoUrl = canvas.toDataURL("image/png");

      self.pessoa.nome = self.pessoa.nome_social;
      self.pessoa.foto = self.fotoUrl;

      self.fecharCamera();

      // Envia para o SIGAP Local processar
      self.enviarParaSigap();
    },
    fecharCamera() {
      const self = this;
      if (self.stream) {
        self.stream.getTracks().forEach((track) => track.stop());
        self.stream = null;
        if (self.$refs.video) {
          self.$refs.video.srcObject = null;
        }
        self.cameraAtiva = false;
      }
    },
    enviarParaSigap() {
      const self = this;

      // API do SIGAP Central que vai encaminhar para o SIGAP Local
      const api = self.$store.state.api + "enviar-para-sigap";

      const payload = {
        atendimento_id: self.senhaAtual.atendimento_id,
        unidade_id: self.unidadeId,
        pessoa: {
          cpf: self.pessoa.cpf ? self.pessoa.cpf : "",
          cns: self.pessoa.cns ? self.pessoa.cns : "",
          nome: self.pessoa.nome_social ? self.pessoa.nome_social : "",
          nome_social: self.pessoa.nome_social ? self.pessoa.nome_social : "",
          nome_mae: self.pessoa.nome_mae ? self.pessoa.nome_mae : "",
          nome_pai: self.pessoa.nome_pai ? self.pessoa.nome_pai : "",
          cep: self.pessoa.cep ? self.pessoa.cep : "",
          logradouro: self.pessoa.logradouro ? self.pessoa.logradouro : "",
          numero: self.pessoa.numero ? self.pessoa.numero : "",
          complemento: self.pessoa.complemento ? self.pessoa.complemento : "",
          bairro: self.pessoa.bairro ? self.pessoa.bairro : "",
          cidade: self.pessoa.cidade ? self.pessoa.cidade : "",
          estado: self.pessoa.estado ? self.pessoa.estado : "",
          telefone: self.pessoa.telefone ? self.pessoa.telefone : "",
          rg: self.pessoa.rg ? self.pessoa.rg : "",
          email: self.pessoa.email ? self.pessoa.email : "",
          alergias: self.pessoa.alergias ? self.pessoa.alergias : "",
          data_nascimento: self.pessoa.data_nascimento_form
            ? self.pessoa.data_nascimento_form
            : "",
          sexo: self.pessoa.sexo ? self.pessoa.sexo : "",
        },
        foto: self.fotoUrl, // Base64 da foto
      };

      axios
        .post(api, payload)
        .then((response) => {
          self.$message(
            "Sucesso",
            "Informações atualizadas com sucesso!",
            "success"
          );

          // Fecha o modal
          $("#modalEditarPessoa").modal("hide");
        })
        .catch((error) => {
          console.error("Erro ao enviar dados:", error);
          self.$message(
            "Erro",
            error.response?.data?.message || "Erro ao atualizar informações",
            "error"
          );
        });
    },
  },
  mounted() {
    const self = this;
    let unidadeId = self.$route.params.unidade_id;
    let atendimentoId = self.$route.params.atendimento_id;

    self.unidadeId = unidadeId;

    var token = localStorage.getItem("token");

    if (!token) {
      self.login();
    } else {
      if (atendimentoId) {
        self.getSenha(atendimentoId);
      }
    }
  },
  beforeDestroy() {
    // Limpa o polling ao sair da página
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },
  created() {},
};
</script>

<style scoped>
.painel-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.painel-content {
  width: 100%;
  max-width: 500px;
  padding: 20px;
}

/* Header com a Senha */
.senha-header {
  background: #17a2b8;
  border-radius: 50px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.senha-text {
  display: flex;
  align-items: center;
  gap: 10px;
  color: white;
  font-weight: bold;
  font-size: 1.5rem;
}

.senha-label {
  font-size: 1.2rem;
}

.senha-numero {
  font-size: 2rem;
  letter-spacing: 2px;
}

/* Informação do Setor */
.setor-info {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border-radius: 15px;
  padding: 12px 20px;
  text-align: center;
  font-size: 1rem;
  margin-bottom: 15px;
  backdrop-filter: blur(10px);
}

/* Botão Preferencial */
.btn-preferencial {
  background: #dc3545;
  color: white;
  border-radius: 50px;
  padding: 15px 25px;
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
}

/* Botão Editar */
.btn-editar {
  background: #17a2b8;
  color: white;
  border-radius: 50px;
  padding: 15px 25px;
  text-align: center;
  font-weight: bold;
  font-size: 0.95rem;
  margin-bottom: 30px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-transform: uppercase;
}

/* Círculo de Progresso */
.progress-circle-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
}

.progress-ring {
  transform: rotate(-90deg);
  max-width: 100%;
  height: auto;
}

.progress-ring-circle-bg {
  opacity: 0.3;
}

.progress-ring-circle {
  transition: stroke-dasharray 0.5s ease;
  stroke-linecap: round;
}

.progress-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.posicao-label {
  font-size: 1rem;
  color: #ffffff;
  margin-bottom: 5px;
  font-weight: 500;
}

.posicao-numero {
  font-size: 4.5rem;
  font-weight: bold;
  color: #ffffff;
  line-height: 1;
}

/* Card de Chamada */
.chamada-card {
  background: #dc3545;
  border-radius: 25px;
  padding: 30px;
  text-align: center;
  color: white;
  box-shadow: 0 4px 20px rgba(220, 53, 69, 0.3);
  margin: 30px 0;
}

.chamada-titulo {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 20px;
  text-transform: uppercase;
}

.chamada-destino {
  font-size: 1.3rem;
  margin-bottom: 20px;
  line-height: 1.6;
}

.chamada-destino strong {
  font-size: 1.8rem;
  display: block;
  margin-top: 10px;
}

.chamada-vezes {
  font-size: 1rem;
  opacity: 0.9;
  margin-top: 15px;
}

/* Card Horário */
.horario-card {
  background: #2c3e50;
  border-radius: 25px;
  padding: 25px;
  text-align: center;
  color: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.horario-title {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.horario-valor {
  font-size: 2rem;
  font-weight: bold;
  color: #17a2b8;
  margin-bottom: 10px;
}

.horario-obs {
  font-size: 0.9rem;
  font-style: italic;
  opacity: 0.8;
}

/* Responsividade */
@media (max-width: 600px) {
  .senha-numero {
    font-size: 1.5rem;
  }

  .posicao-numero {
    font-size: 4rem;
  }

  .progress-ring {
    width: 240px;
    height: 240px;
  }
}
</style>
